import styled, { css } from "styled-components";

const OverflowSpan = styled.span`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-weight: bold;

    >svg{
        margin-left: 0.25rem;
        margin-right: 0.5rem;
    }
`;

export const styleInlineListKR = css`
    .infoCircleDescription-kr{
        display: none;
    }
    .list-component-child:hover{
        .infoCircleDescription-kr{
            display: flex;
        }
    }
`;

export const StyledDivDescriptionAndAlertExclamation = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 0.25rem;
    flex: 1;
`;

export default OverflowSpan;
